import React, { useMemo } from 'react';
import { formatCurrency } from '../../../utils/formatters';
import DashboardCard, { ChartEmpty, MONEY_CLASS, NUM_CLASS } from './DashboardCard';
import { cn } from '@/lib/utils';

interface LtvRankingItem {
    id: string;
    name: string;
    totalValue: number;
    dealsCount: number;
}

interface LtvRankTableProps {
    ranking: LtvRankingItem[];
}

const LtvRankTable: React.FC<LtvRankTableProps> = ({ ranking }) => {
    const rows = useMemo(() => ranking.slice(0, 5), [ranking]);

    return (
        <DashboardCard title="Ranking LTV" flush>
            {rows.length === 0 ? (
                <ChartEmpty>Nenhum cliente com LTV neste período.</ChartEmpty>
            ) : (
                <div className="overflow-x-auto">
                    <table className="tbl">
                        <thead>
                            <tr>
                                <th scope="col" className="w-10">#</th>
                                <th scope="col">Cliente</th>
                                <th scope="col" className="text-right">Neg.</th>
                                <th scope="col" className="text-right">LTV</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((client, index) => {
                                const rank = index + 1;
                                return (
                                    <tr key={client.id}>
                                        <td>
                                            <span className={cn(NUM_CLASS, 'text-sm', rank <= 3 ? 'text-primary' : 'text-muted')}>
                                                #{rank}
                                            </span>
                                        </td>
                                        <td className="max-w-0 truncate font-sans text-sm font-normal text-muted" title={client.name}>
                                            {client.name}
                                        </td>
                                        <td className={cn(NUM_CLASS, 'text-right text-sm text-muted')}>{client.dealsCount}</td>
                                        <td className={cn(MONEY_CLASS, 'whitespace-nowrap text-right text-sm text-primary')}>
                                            {formatCurrency(client.totalValue)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </DashboardCard>
    );
};

export default LtvRankTable;
